export function setAttr(selection, attributes) {
  Object.entries(attributes).forEach(([name, value]) => {
    selection.attr(name, value);
  });
  return selection;
}